
import React from 'react'
import Icon from './Icon'

const FaAngleRight = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m26.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z"/></g>
    </Icon>
)

export default FaAngleRight



// WEBPACK FOOTER //
// ./src/components/Icon/angle-right.js